const React = require("react");
const T = React.PropTypes;

const baseStyle = {
    padding: "7px 8px 8px 8px",
    color: "#fff",
    borderRadius: "50%",
    boxShadow: "0 3px 5px #888"
};

const ProcessingMark = React.createClass({
    propTypes: {
        onClick: T.func,
        style: T.object
    },
    getDefaultProps() {
        return {
            style: {}
        };
    },
    getInitialState() {
        return {
            DisplayToggle: false,
            ToggleHandle: 0
        };
    },
    componentDidMount() {
        const handle = setTimeout(this.Toggle, 1000);

        this.setState({
            ToggleHandle: handle
        });
    },
    render() {
        var iconStyle = {};

        if (this.state.DisplayToggle) {
            iconStyle = {
                position: "absolute",
                top: 5,
                transition: "top 300ms"
            };
        }
        else {
            iconStyle = {
                position: "absolute",
                top: 0,
                transition: "top 300ms"
            };
        }

        iconStyle = Object.assign(iconStyle, baseStyle, { backgroundColor: "#0af" });

        return (<div style={this.props.style}>
            <span className="glyphicon glyphicon-time bg-info" style={iconStyle}></span>
        </div>);
    },
    componentWillUnmount() {
        clearTimeout(this.state.ToggleHandle);
    },
    Toggle() {
        this.setState({
            DisplayToggle: !this.state.DisplayToggle
        });
        
        const timeOut =
            this.state.DisplayToggle
            ? 300 // Down
            : 1000; // Up

        const handle = setTimeout(this.Toggle, timeOut);

        this.setState({
            ToggleHandle: handle
        });
    }
});

module.exports = ProcessingMark;


// WEBPACK FOOTER //
// ./src/components/ProcessingMark.jsx